import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as s } from "../../../../IconBase-CxZyIWw2.js";
const t = i((e, l) => /* @__PURE__ */ o.jsx(
  s,
  {
    ref: l,
    ...e,
    image: (r) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m4-9V5H4v2zm0 4V9H4v2z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
t.displayName = "EqualIcon";
export {
  t as EqualIcon,
  t as default
};
//# sourceMappingURL=index.js.map
